import { useState } from 'react'

export const usePasswordVisibility = (initialVisible: boolean = false) => {
  const [visible, setVisible] = useState(initialVisible)

  const toggle = () => setVisible((prev) => !prev)

  const show = () => setVisible(true)

  const hide = () => setVisible(false)

  return {
    visible,
    toggle,
    show,
    hide,
    setVisible,
  }
}
